import React from "react";
import Layout from "../../components/Layout";
import ScrollToTop from "../../components/ScrollToTop";
import SessionCheck from "../../components/SessionCheck";
import NavHeader from "../../components/NavHeader";
import BvnOtpVerification from "../../views/MortgageView/bvn-otp-verification";

const MortgageBvnOtpVerification = () => {
  return (
    <Layout>
      <ScrollToTop />
      <SessionCheck shouldRedirect />
      <NavHeader
        pageTitle="Mortgage-Application"
        routeName="bvn-otp-verification"
      />
      <BvnOtpVerification />
    </Layout> 
  );
};

export default MortgageBvnOtpVerification;
